module.exports = __webpack_public_path__ + "media/images/mobile-menu-add13f5aa70de3c8eaf4199a01d33b90.svg";